import {
  ADD_ITEM,
  DELETE_ITEM,
  EDIT_ITEM,
  GET_ITEMS_LIST,
} from '../../modules/constants';

export function getItemsList(value) {
  return {
    type: GET_ITEMS_LIST,
    payload: value,
  };
}

export function addItem(value) {
  return {
    type: ADD_ITEM,
    payload: value,
  };
}

export function editItem(value) {
  return {
    type: EDIT_ITEM,
    payload: value,
  };
}

export function deleteItem(value) {
  return {
    type: DELETE_ITEM,
    payload: value,
  };
}
